import { Box, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const SMS_STANDARD_MAX = 142;

const CHARSET_TOOLTIP = (
  <>
    {`1 SMS = ${SMS_STANDARD_MAX} caractères. Au-delà, le message est découpé en plusieurs SMS.`}
    <br /><br />
    <Box sx={{ fontSize: '0.75rem', lineHeight: 1.6 }}>
      <Box component="span" sx={{ fontWeight: 700 }}>Les caractères suivants sont autorisés :</Box>
      <br />
      0 1 2 3 4 5 6 7 8 9
      <br />
      A B C D E F G H I J K L M N O P Q R S T U V W X Y Z Ä Ö Ñ Ü
      <br />
      a b c d e f g h i j k l m n o p q r s t u v w x y z ä ö ñ ü à
      <br />
      {'! " # % & \\ ( ) * + - . / : , ; < = > ? ¡ § ¿ { } [ ] ~ € ¤ _ ß'}
      <br />
      @ £ $ ¥ è é ù ì ò Ç Ø ø Å å Æ æ É
      <br />
      <br />
      <Box component="span" sx={{ fontWeight: 700 }}>Attention</Box>, les caractères suivants comptent pour deux caractères :
      <br />
      {'€ { } [ ] ~ \\'}
    </Box>
  </>
);

function SmsCounter({ charCount }: { charCount: number }) {
  const smsCount = Math.max(1, Math.ceil(charCount / SMS_STANDARD_MAX));
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.75, mb: 1 }}>
      <Typography variant="caption" fontWeight={700} sx={{ fontSize: '0.78rem', color: 'text.primary' }}>
        {smsCount} sms - {charCount} caractère(s)
      </Typography>
      <Tooltip title={CHARSET_TOOLTIP} slotProps={{ tooltip: { sx: { maxWidth: 420 } } }} arrow>
        <InfoOutlinedIcon sx={{ fontSize: '0.9rem', color: 'text.disabled', cursor: 'help' }} />
      </Tooltip>
    </Box>
  );
}

export default SmsCounter;
